export const props = Object.freeze({
  /**
   * Id of the native `<select>` this control mirrors. The element reads its options and
   * current value from that select, and writes the chosen value back to it — dispatching a
   * bubbling change event on the select's form so the surrounding search refreshes.
   *
   * @type {String}
   */
  selectId: {
    type: String,
    required: true,
  },
  /**
   * CSS selector for the near/location filter element. Selecting the distance sort without a
   * location opens that filter and scrolls it into view; filling a location in it closes this
   * control.
   *
   * @type {String}
   */
  nearFilterSelector: {
    type: String,
    required: true,
  },
  /**
   * Heading of the sort dialog.
   *
   * @type {String}
   * @default "Sort results by"
   */
  title: {
    type: String,
    default: "Sort results by",
  },
  /**
   * Label of the dialog's confirm button.
   *
   * @type {String}
   * @default "Done"
   */
  closeText: {
    type: String,
    default: "Done",
  },
  /**
   * Prefix shown before the selected option on the trigger, as "Sort: Recommended". Pass an
   * empty string to show the option label alone.
   *
   * @type {String}
   * @default "Sort"
   */
  triggerPrefix: {
    type: String,
    default: "Sort",
  },
});
